import { render, staticRenderFns } from "./SettlementForm.vue?vue&type=template&id=38b117d8&scoped=true&"
import script from "./SettlementForm.vue?vue&type=script&lang=js&"
export * from "./SettlementForm.vue?vue&type=script&lang=js&"
import style0 from "./SettlementForm.vue?vue&type=style&index=0&id=38b117d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b117d8",
  null
  
)

export default component.exports